import { Avatar, Flex, Text } from '@chakra-ui/react';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { ScorecardUser } from '../GenerateScorecard.interface';

interface ScorecardPDFHeaderProps {
  candidate: ScorecardUser | null;
  jobTitle?: string | null;
  createdBy?: ScorecardUser | null;
}

export const ScorecardPDFHeader = ({
  candidate,
  jobTitle,
  createdBy,
}: ScorecardPDFHeaderProps) => {
  const candidateSection = () => (
    <Flex
      flexDir="column"
      gap="8px"
      minW="150px"
      flex="1 1 auto"
      overflow="hidden"
    >
      <Text size="sm-semi-bold">Candidate</Text>
      <Flex gap="6px" alignItems="center" minW={0} flex={1}>
        <Avatar
          w="20px"
          h="20px"
          borderRadius="xs"
          src={candidate?.avatar || undefined}
          name={candidate?.name}
          className="avatar-xs"
          flexShrink={0}
        />
        <TruncatedTextWithTooltip
          size="sm-medium"
          text={candidate?.name || 'N/A'}
          enableTooltip={true}
        />
      </Flex>
    </Flex>
  );

  const jobSection = () => {
    if (!jobTitle) return null;
    return (
      <Flex
        flexDir="column"
        gap="8px"
        minW="150px"
        flex="1 1 auto"
        overflow="hidden"
      >
        <Text size="sm-semi-bold">Job</Text>
        <TruncatedTextWithTooltip
          size="sm-medium"
          text={jobTitle}
          enableTooltip={true}
        />
      </Flex>
    );
  };

  const createdBySection = () => {
    if (!createdBy?.name) return null;
    return (
      <Flex
        flexDir="column"
        gap="8px"
        minW="150px"
        flex="1 1 auto"
        overflow="hidden"
      >
        <Text size="sm-semi-bold">Created by</Text>
        <Flex gap="6px" alignItems="center" minW={0} flex={1}>
          <Avatar
            w="20px"
            h="20px"
            borderRadius="xs"
            src={createdBy?.avatar || undefined}
            name={createdBy?.name}
            className="avatar-xs"
            flexShrink={0}
          />
          <TruncatedTextWithTooltip
            size="sm-medium"
            text={createdBy?.name}
            enableTooltip={true}
          />
        </Flex>
      </Flex>
    );
  };

  return (
    <Flex p="10px 0px 12px 0px" w="100%" maxW="100%" mb="16px">
      <Flex
        w="100%"
        p="12px"
        gap="24px"
        justifyContent="flex-start"
        flexDir="row"
        alignItems="center"
        bg="secondary-25"
        borderRadius="sm"
      >
        {candidateSection()}
        {jobSection()}
        {createdBySection()}
      </Flex>
    </Flex>
  );
};
